// @ts-nocheck
const COOKIE_NAME = 'mtLang';
const ONE_YEAR_SECONDS = 365 * 24 * 60 * 60;

const isBrowser = () =>
  typeof window !== 'undefined' && typeof document !== 'undefined';

const getCookieDomain = () => {
  if (!isBrowser()) {
    return null;
  }
  const { hostname } = window.location;
  if (!hostname) {
    return null;
  }
  if (hostname === 'localhost' || hostname.endsWith('.local')) {
    return null;
  }
  if (hostname.endsWith('magictableplanner.com')) {
    return '.magictableplanner.com';
  }
  return null;
};

export const readLanguageCookie = () => {
  if (!isBrowser()) {
    return null;
  }
  const cookies = document.cookie ? document.cookie.split(';') : [];
  for (const cookie of cookies) {
    const [rawName, ...rawValueParts] = cookie.split('=');
    if (!rawName) {
      continue;
    }
    const name = rawName.trim();
    if (name !== COOKIE_NAME) {
      continue;
    }
    const value = rawValueParts.join('=').trim();
    if (!value) {
      return null;
    }
    try {
      return decodeURIComponent(value);
    } catch (_error) {
      return value;
    }
  }
  return null;
};

const buildCookieString = (value, options = {}) => {
  const segments = [`${COOKIE_NAME}=${encodeURIComponent(value)}`];
  const {
    maxAge = ONE_YEAR_SECONDS,
    domain,
    path = '/',
    sameSite = 'Lax',
    secure,
  } = options;

  if (typeof maxAge === 'number' && Number.isFinite(maxAge)) {
    segments.push(`Max-Age=${Math.trunc(maxAge)}`);
    const expires = new Date(Date.now() + maxAge * 1000).toUTCString();
    segments.push(`Expires=${expires}`);
  }

  if (path) {
    segments.push(`Path=${path}`);
  }

  if (domain) {
    segments.push(`Domain=${domain}`);
  }

  if (sameSite) {
    segments.push(`SameSite=${sameSite}`);
  }

  if (secure) {
    segments.push('Secure');
  }

  return segments.join('; ');
};

export const writeLanguageCookie = (value) => {
  if (!isBrowser() || !value) {
    return;
  }
  const domain = getCookieDomain();
  const secure = window.location.protocol === 'https:';
  document.cookie = buildCookieString(value, { domain, secure });
};

export const clearLanguageCookie = () => {
  if (!isBrowser()) {
    return;
  }
  const domain = getCookieDomain();
  const segments = [`${COOKIE_NAME}=`, 'Max-Age=0', 'Path=/'];
  if (domain) {
    segments.push(`Domain=${domain}`);
  }
  segments.push('Expires=Thu, 01 Jan 1970 00:00:00 GMT');
  document.cookie = segments.join('; ');
};
